import dayjs from "dayjs";
import { Paginated } from "../../../../common/domain/models/paginated_models";
import { Afastamento } from "../../domain/models/afastamento";
import { Cep } from "../../domain/models/cep";
import { ControlePatrimonio } from "../../domain/models/controle_patrimonio";
import { Dependente } from "../../domain/models/dependente";
import { Documento } from "../../domain/models/documento";
import { DocumentoEntregue } from "../../domain/models/documento_entregue";
import { EquipamentoDropDown } from "../../domain/models/equipamento_dropdown";
import { Evento } from "../../domain/models/evento";
import { Ferias } from "../../domain/models/ferias";
import { Funcionario } from "../../domain/models/funcionario";
import { FuncionarioFilters } from "../../domain/models/funcionarios_filters";
import { AvaliacaoHabilidade } from "../../domain/models/avaliacao_habilidade";
import { HabilidadeDropDown } from "../../domain/models/habilidade_dropdown";
import { HabilidadeItem } from "../../domain/models/habilidade_item";
import { ItemVerbaDropDown } from "../../domain/models/item_verba_dropdown";
import { MotivoAfastamentoDropDown } from "../../domain/models/motivo_afastamento_dropdown";
import { MotivoDemissaoDropDown } from "../../domain/models/motivo_demissao_dropdown";
import { FuncionarioTreinamento } from "../../domain/models/funcionario_treinamento";
import { TreinamentoDropDown } from "../../domain/models/treinamento_dropdown";
import { IRhRepository } from "../../domain/repositories/rh_repository";
import { GetFuncionariosRequest } from "../daos/read/get_funcionarios";
import { IRhService } from "../services/rh_service";
import { CentroCustoSecundario } from "../../domain/models/centro_custo_secundario";
import { FuncionarioTabela } from "../../domain/models/funcionario_tabela";
import { MotivoDemissao } from "../../domain/models/motivo_demissao";
import { FuncionarioAssinatura } from "../../domain/models/funcionario_assinatura";
import { MotivoAfastamento } from "../../domain/models/motivo_afastamento";
import { Cargo } from "../../domain/models/cargo";
import { CargoTreinamento } from "../../domain/models/cargo_treinamento";
import { CargoHabilidade } from "../../domain/models/cargo_habilidade";
import { CargoCompleto } from "../../domain/models/cargo_completo";
import { Treinamento } from "../../domain/models/treinamento";
import { TreinamentoTreinamentoCargo } from "../../domain/models/treinamento_treinamento_cargo";
import { CargoTreinamentoCargo } from "../../domain/models/cargo_treinamento_cargo";
import { FuncionarioSetorDropDown } from "../../domain/models/funcionario_setor_dropdown";
import { FuncionarioFilialDropDown } from "../../domain/models/funcionario_filial_dropdown";
import { FuncionarioNomeDropDown } from "../../domain/models/funcionario_nome_dropdown";
import { Habilidade } from "../../domain/models/habilidade";
import { HabilidadeHabilidadeCargo } from "../../domain/models/habilidade_habilidade_cargo";
import { CargoHabilidadeCargo } from "../../domain/models/cargo_habilidade_cargo";
import { AvaliacaoTreinamento } from "../../domain/models/avaliacao_treinamento";
import { TreinamentoFuncionario } from "../../domain/models/treinamento_funcionario";
import { TreinamentoFuncionarioData } from "../../domain/models/treinamento_funcionario_data";
import { TreinamentoFuncionarioAssinatura } from "../../domain/models/treinamento_funcionario_assinatura";
import { TreinamentoFuncionarioInstrutor } from "../../domain/models/treinamento_funcionario_instrutor";
import { TreinamentoFuncionarioLocal } from "../../domain/models/treinamento_funcionario_local";
import { FolhaPagamento } from "../../domain/models/folha_pagamento";
import { ItemFolhaPagamento } from "../../domain/models/item_folha_pagamento";
import { SubcontaDropdown } from "../../domain/models/subconta_dropdown";
import { FolhaPagamentoDetalhe } from "../../domain/models/folha_pagamento_detalhe";
import { ItemFolhaPagamentoDetalhe } from "../../domain/models/item_folha_pagamento_detalhe";
import { ItemFolhaPagamentoVerba } from "../../domain/models/item_folha_pagamento_verba";
import { ItemVerbaFuncionarioDropDown } from "../../domain/models/item_verba_funcionario_dropdown";
import { BancoPagamentoDropDown } from "../../domain/models/banco_pagamento_dropdown";
import { FolhaPagamentoDropDown } from "../../domain/models/folha_pagamento_dropdown";
import { FiltroFolhaPagamento } from "../../domain/models/filtro_folha_pagamento";
import { VerbaPagamento } from "../../domain/models/verba_pagamento";
import { FuncionarioAssinaturaDropDown } from "../../domain/models/funcionario_assinatura_dropdown";
import { DashboardRh } from "../../domain/models/dashboard_rh";
import { CreateBiometriaFacialResponse } from "../daos/create/create_biometria_facial";
import { BiometriaFacial } from "../../domain/models/biometria_facial";
import { JobStatusResponse } from "../../../../common/domain/models/job_status_response";

/**
 * RhRepository
 */

export class RhRepository implements IRhRepository {
  constructor(private readonly service: IRhService) { }

  async getItensVerbaDropDown(): Promise<ItemVerbaDropDown[]> {
    const response = await this.service.getItensVerbaDropDown();
    return [...response.items];
  }

  async getMotivosAfastamentoDropDown(): Promise<MotivoAfastamentoDropDown[]> {
    const response = await this.service.getMotivosAfastamentoDropDown();
    return [
      ...response.items.map(
        (x): MotivoAfastamentoDropDown => ({
          idMotivoAfastamento: x.idMotivoAfastamento,
          descricao: x.descricaoMotivo ?? "",
        }),
      ),
    ];
  }

  async getMotivosDemissaoDropDown(): Promise<MotivoDemissaoDropDown[]> {
    const response = await this.service.getMotivosDemissaoDropDown();
    return [
      ...response.items.map(
        (x): MotivoDemissaoDropDown => ({
          idMotivoDemissao: x.idMotivoDemissao,
          descricao: x.descricaoMotivo,
        }),
      ),
    ];
  }

  async getTreinamentosDropDown(): Promise<TreinamentoDropDown[]> {
    const response = await this.service.getTreinamentosDropDown();
    return [...response.items];
  }

  async getHabilidadesDropDown(): Promise<HabilidadeDropDown[]> {
    const response = await this.service.getHabilidadesDropDown();
    return [...response.items];
  }

  async getEquipamentosDropDown(): Promise<EquipamentoDropDown[]> {
    const response = await this.service.getEquipamentosDropDown();
    return [
      ...response.items.map(
        (x): EquipamentoDropDown => ({
          idEquipamento: x.idMaquinaEquip,
          descricao: x.descricao,
        }),
      ),
    ];
  }

  async getFuncionarioSetoresDropDown(): Promise<FuncionarioSetorDropDown[]> {
    const response = await this.service.getFuncionarioSetoresDropDown();
    return response.items;
  }

  async getFuncionarioNomesDropDown(): Promise<FuncionarioNomeDropDown[]> {
    const response = await this.service.getFuncionarioNomesDropDown();
    return response.items;
  }

  async getFuncionarioFiliaisDropDown(): Promise<FuncionarioFilialDropDown[]> {
    const response = await this.service.getFuncionarioFiliaisDropDown();
    return response.items;
  }

  async getFolhaPagamentoDropDown(): Promise<FolhaPagamentoDropDown[]> {
    const response = await this.service.getFolhaPagamentoDropDown({});
    return response.itens;
  }

  async getFolhaPagamentoDetalhadaDropDown(): Promise<
    FolhaPagamentoDropDown[]
  > {
    const response = await this.service.getFolhaPagamentoDetalhadaDropDown({});
    return response.itens;
  }

  async getBancoPagamentoDropDown(): Promise<BancoPagamentoDropDown[]> {
    const response = await this.service.getBancoPagamentoDropDown({});
    return response.itens;
  }

  async getItemVerbaFuncionarioDropDown(
    idItemVerbaFuncionario: number,
  ): Promise<ItemVerbaFuncionarioDropDown[]> {
    const response = await this.service.getAllItemVerbaFuncionarioDropDown({
      idItemVerbaFuncionario,
    });
    return response.itens;
  }

  async getFuncionarioAssinaturaDropDown(): Promise<
    FuncionarioAssinaturaDropDown[]
  > {
    const response = await this.service.getFuncionarioAssinaturaDropDown({});
    return response.itens;
  }

  async getFuncionarios(
    telaId: number,
    filters: FuncionarioFilters,
    sortField: string,
    sort: "asc" | "desc",
    page: number,
    pageSize: number,
  ): Promise<Paginated<FuncionarioTabela>> {
    const request: GetFuncionariosRequest = {
      telaId,
      pesquisarPor: filters.tipoPesquisa,
      pesquisar: filters.pesquisa,
      pesquisarSetor: filters.setor,
      pesquisarFilial: filters.filial,
      admissaoDe: filters.admissaoDe,
      admissaoAte: filters.admissaoAte,
      demissaoDe: filters.demissaoDe,
      demissaoAte: filters.demissaoAte,
      afastamentoDe: filters.afastamentoDe,
      afastamentoAte: filters.afastamentoAte,
      feriasDe: filters.feriasDe,
      feriasAte: filters.feriasAte,
      treinamento: filters.treinamentos,
      prazoExperiencia: filters.prazoExperiencia,
      documento: filters.documentos,
      centroCusto: filters.centroDeCusto,
      status: filters.status,
      sortField: sortField,
      sort: sort,
      page: page,
      pageSize: pageSize,
    };

    const response = await this.service.getFuncionarios(request);

    return {
      ...response,
      items: response.items.map(
        (x): FuncionarioTabela => ({
          idFuncionario: x.idFuncionario,
          idCentroCusto: x.idCentroCusto,
          idCargo: x.idCargo,
          nome: x.nome,
          status: x.status,
          statusDocumentos: x.statusDocumentos,
          statusAvaliacaoHabilidades: x.statusAvaliacaoHabilidades,
          statusAvaliacaoTreinamentos: x.statusAvaliacaoTreinamentos,
          statusExperiencias: x.statusExperiencias,
          situacao: x.situacao,
          dataAdmissao: x.dataAdmissao ? dayjs(x.dataAdmissao).toDate() : null,
          dataDemissao: x.dataDemissao ? dayjs(x.dataDemissao).toDate() : null,
          dataAfastamento: x.dataAfastamento
            ? dayjs(x.dataAfastamento).toDate()
            : null,
          cargoDescricao: x.cargoDescricao,
          centroCustoDescricao: x.centroCustoDescricao,
          tamanho: x.tamanho,
          dataInicioFerias: x.dataInicioFerias
            ? dayjs(x.dataInicioFerias).toDate()
            : null,
          dataFimFerias: x.dataFimFerias
            ? dayjs(x.dataFimFerias).toDate()
            : null,
        }),
      ),
    };
  }

  async getCep(cep: string): Promise<Cep> {
    try {
      const response = await this.service.getCep({ cep });

      if (response.cep.erro === "true") {
        return {
          uf: "",
          cidade: "",
          bairro: "",
          tipo_logradouro: "",
          logradouro: "",
          pais: "",
        };
      }

      return {
        uf: response.cep.uf,
        cidade: response.cep.localidade,
        bairro: response.cep.bairro,
        tipo_logradouro: "",
        logradouro: response.cep.logradouro,
        pais: "Brasil",
      };
    } catch (e: unknown) {
      return {
        uf: "",
        cidade: "",
        bairro: "",
        tipo_logradouro: "",
        logradouro: "",
        pais: "",
      };
    }
  }

  async getDocumentos(
    idFuncionario: number,
    page: number,
    pageSize: number,
  ): Promise<Paginated<Documento>> {
    const response = await this.service.getDocumentos({
      idFuncionario,
      page,
      pageSize,
    });
    return {
      ...response,
      items: response.items.map(
        (x): Documento => ({
          idDocumento: x.idFuncionarioArquivo,
          status: x.status ?? 0,
          situacao: x.situacao ?? 0,
          dataVencimento: x.dataVencimento
            ? dayjs(x.dataVencimento).toDate()
            : null,
          dataEmissao: x.dataEmissao ? dayjs(x.dataEmissao).toDate() : null,
          descricao: x.descricao ?? "",
          nome: x.nome,
        }),
      ),
    };
  }

  async getDocumentosEntregues(
    idFuncionario: number,
    page: number,
    pageSize: number,
  ): Promise<Paginated<DocumentoEntregue>> {
    const response = await this.service.getDocumentosEntregues({
      idFuncionario,
      page,
      pageSize,
    });
    return {
      ...response,
      items: response.items.map(
        (x): DocumentoEntregue => ({
          idDocumentoEntregue: x.idDocumentoEntregue,
          idDocumento: x.idDocumento,
          entregue: x.selecionado,
          naoSeAplica: x.naoSeAplica,
          observacao: x.descricao ?? "",
        }),
      ),
    };
  }

  async getFuncionarioTreinamentos(
    idFuncionario: number,
    page: number,
    pageSize: number,
  ): Promise<Paginated<FuncionarioTreinamento>> {
    const response = await this.service.getFuncionarioTreinamentos({
      idFuncionario,
      page,
      pageSize,
    });
    return {
      ...response,
      items: response.items.map(
        (x): FuncionarioTreinamento => ({
          idFuncionarioTreinamento: x.idFuncionarioTreinamento,
          idTreinamento: x.idTreinamento,
          avaliarTreinamento: x.avaliarTreinamento,
          status: x.status,
          treinamento: x.treinamento,
          versao: x.versao,
          local: x.local,
          instrutor: x.instrutor ?? "",
          prazo: x.previAvaliacao,
          dataInicio: x.dataInicio ? dayjs(x.dataInicio).toDate() : null,
          dataPrevAvaliacao: x.dataPrevAvaliacao
            ? dayjs(x.dataPrevAvaliacao).toDate()
            : null,
          dataAvaliacao: x.dataAvaliacao
            ? dayjs(x.dataAvaliacao).toDate()
            : null,
          avaliador: x.avaliador ?? "",
          eficaz: x.eficaz,
          assinado: x.assinado,
          cargaHoraria: x.cargaHoraria,
          evidenciaObjetiva: x.evidenciaObjetiva,
        }),
      ),
    };
  }

  async getAvaliacaoHabilidades(
    idFuncionario: number,
    page: number,
    pageSize: number,
  ): Promise<Paginated<AvaliacaoHabilidade>> {
    const response = await this.service.getAvaliacaoHabilidades({
      idFuncionario,
      page,
      pageSize,
    });
    return {
      ...response,
      items: response.items.map(
        (x): AvaliacaoHabilidade => ({
          idAvaliacaoHabilidade: x.idAvaliacaoHabilidade,
          idAvaliadoPor: x.idFuncionarioAvaliador,
          prazoAvaliacao: x.dataAvaliacao
            ? dayjs(x.dataAvaliacao).toDate()
            : null,
          dataAvaliacao: x.dataAvaliacaoReal
            ? dayjs(x.dataAvaliacaoReal).toDate()
            : null,
          avaliacao: x.descricao,
          avaliador: x.avaliador,
          totalPontos: x.nota,
          status: x.status ?? 0,
          descricao: x.descricao ?? "",
          dataReavaliacao: x.dataReavaliacao
            ? dayjs(x.dataReavaliacao).toDate()
            : null,
          observacao: x.observacoes ?? "",
        }),
      ),
    };
  }

  async getDependentes(
    idFuncionario: number,
    page: number,
    pageSize: number,
  ): Promise<Paginated<Dependente>> {
    const response = await this.service.getDependentes({
      idFuncionario,
      page,
      pageSize,
    });
    return {
      ...response,
      items: response.items.map(
        (x): Dependente => ({
          idDependente: x.idFuncionarioDependente,
          nome: x.nome ?? "",
          grauParentesco: x.grauParentesco ?? "",
          rg: x.identidade ?? "",
          cpf: x.cpf ?? "",
          dataNascimento: x.dataNascimento
            ? dayjs(x.dataNascimento).toDate()
            : null,
        }),
      ),
    };
  }

  async getEventos(
    idFuncionario: number,
    page: number,
    pageSize: number,
  ): Promise<Paginated<Evento>> {
    const response = await this.service.getEventos({
      idFuncionario,
      page,
      pageSize,
    });
    return {
      ...response,
      items: response.items.map(
        (x): Evento => ({
          idItemVerbaFuncionario: x.idItemVerbaFuncionario,
          idItemVerba: x.idItemVerba,
          nr: x.nrItemVerba ?? "",
          tipo: x.tipo ?? 0,
          item: x.item ?? "",
          valorUnitario: x.valorVerba ?? 0,
          descricao: x.descricao,
        }),
      ),
    };
  }

  async getFerias(
    idFuncionario: number,
    page: number,
    pageSize: number,
  ): Promise<Paginated<Ferias>> {
    const response = await this.service.getFerias({
      idFuncionario,
      page,
      pageSize,
    });
    return {
      ...response,
      items: response.items.map(
        (x): Ferias => ({
          idFerias: x.idFuncionarioFerias,
          descricao: x.descricao ?? "",
          dataInicio: dayjs(x.dataInicio).toDate(),
          dataTermino: dayjs(x.dataTermino).toDate(),
        }),
      ),
    };
  }

  async getAfastamentos(
    idFuncionario: number,
    page: number,
    pageSize: number,
  ): Promise<Paginated<Afastamento>> {
    const response = await this.service.getAfastamentos({
      idFuncionario,
      page,
      pageSize,
    });
    return {
      ...response,
      items: response.items.map(
        (x): Afastamento => ({
          idAfastamento: x.idFuncionarioAfastamento,
          idMotivoAfastamento: x.idMotivoAfastamento,
          motivoAfastamento: x.motivoAfastamento ?? "",
          dataInicio: x.dataInicio ? dayjs(x.dataInicio).toDate() : null,
          dataTermino: x.dataTermino ? dayjs(x.dataTermino).toDate() : null,
          observacao: x.observacao ?? "",
        }),
      ),
    };
  }

  async getHabilidadeItems(
    idAvaliacaoHabilidade?: number,
    page?: number,
    pageSize?: number,
  ): Promise<Paginated<HabilidadeItem>> {
    const request = {
      idAvaliacaoHabilidade: idAvaliacaoHabilidade ?? null,
      page: page ?? null,
      pageSize: pageSize ?? null,
    };
    const response = await this.service.getHabilidadeItems({ ...request });
    return {
      ...response,
      items: response.items.map(
        (x): HabilidadeItem => ({
          idHabilidadeItem: x.idFuncionarioHabilidade,
          idHabilidade: x.idHabilidade,
          habilidade: x.tipo ?? "",
          nota: x.nota,
        }),
      ),
    };
  }

  async getControlePatrimonios(
    idFuncionario: number,
    page: number,
    pageSize: number,
  ): Promise<Paginated<ControlePatrimonio>> {
    const response = await this.service.getControlePatrimonios({
      idFuncionario,
      page,
      pageSize,
    });
    return {
      ...response,
      items: response.items.map(
        (x): ControlePatrimonio => ({
          idControlePatrimonio: x.idControlePatrimonio,
          idMaquinaEquip: x.idMaquinaEquip,
          codigo: x.codigo ?? "",
          descricao: x.descricao ?? "",
          dataEntrega: x.dataEntrega ? dayjs(x.dataEntrega).toDate() : null,
          dataDevolucao: x.dataDevolucao
            ? dayjs(x.dataDevolucao).toDate()
            : null,
          arquivo: x.arquivo,
          nomeArquivo: x.nomeArquivo,
          observacao: x.observacao,
        }),
      ),
    };
  }

  async getCentroCustoSecundarios(
    idFuncionario: number,
    page: number,
    pageSize: number,
  ): Promise<Paginated<CentroCustoSecundario>> {
    const response = await this.service.getCentroCustoSecundarios({
      idFuncionario,
      page,
      pageSize,
    });
    return { ...response };
  }

  async getFuncionarioById(idFuncionario: number): Promise<Funcionario | null> {
    const funcionario = await this.service.getFuncionarioEnderecoById({
      idFuncionario,
    });

    if (!funcionario) return null;

    return {
      idFuncionario: funcionario.idFuncionario,
      idCargo: funcionario.idCargo,
      idCentroCusto: funcionario.idCentroCusto,
      nome: funcionario.nome,
      sexo: funcionario.sexo,
      regime: funcionario.regimeContratacao,
      dataAdmissao: dayjs(funcionario.dataadmissao).toDate(),
      dataNascimento: funcionario.datanascimento
        ? dayjs(funcionario.datanascimento).toDate()
        : null,
      idMotivoDemissao: funcionario.idMotivoDemissao,
      dataDemissao: funcionario.datademissao
        ? dayjs(funcionario.datademissao).toDate()
        : null,
      setor: funcionario.setor,
      avaliarHabilidadesEm: funcionario.tempoexperiencia,
      descontoSindical: funcionario.descontoSindical,
      imagem: null,
      filial: funcionario.filial,
      email1: funcionario.email,
      email2: funcionario.email1,
      matricula: funcionario.matricula,
      telefoneMovel: funcionario.telcelular,
      telefoneFixo: funcionario.telfixo,
      horarioTrabalho: funcionario.horariotrabalho,
      horarioAlmoco: funcionario.horarioalmoco,
      nacionalidade: funcionario.nacionalidade,
      naturalidade: funcionario.naturalidade,
      estado: funcionario.estado,
      cpf: funcionario.cpf,
      numeroPis: funcionario.pis,
      estadoCivil: funcionario.estadoCivil,
      salario: funcionario.salario,
      periodo: funcionario.periodo,
      experiencia: funcionario.experiencia,
      prorrogarEm: funcionario.prorrogarEm,
      aprovadoExperiencia:
        funcionario.aprovadoExperiencia !== null
          ? funcionario.aprovadoExperiencia
            ? 1
            : 0
          : null,
      escolaridade: funcionario.escolaridade,
      cargaHorarioMensal: funcionario.cargaHoraria,
      valeTransporte: funcionario.valeTransporte,
      valorValeTransporte: funcionario.valorValeTransporte,
      ctps: funcionario.ctps,
      ctpsSerie: funcionario.serie,
      ctpsEstado: funcionario.ctpsUf,
      ctpsDataEmissao: funcionario.dataEmissao
        ? dayjs(funcionario.dataEmissao).toDate()
        : null,
      rg: funcionario.rg,
      rgDataExped: funcionario.dataExpedicao
        ? dayjs(funcionario.dataExpedicao).toDate()
        : null,
      rgOrgaoExped: funcionario.orgExp,
      rgEstado: funcionario.rgUf,
      tituloEleitor: funcionario.tituloEleitor,
      tituloZona: funcionario.zona,
      tituloSecao: funcionario.secao,
      reservista: funcionario.reservista,
      nomeMae: funcionario.nomeMae,
      nomePai: funcionario.nomePai,
      conjugeNome: funcionario.nomeConjugue,
      conjugeRg: funcionario.identidadeConjuge,
      conjugeCpf: funcionario.cpfConjuge,
      complementoCamisaInfo: funcionario.camisa,
      complementoCalcaInfo: funcionario.calça,
      complementoCalcadoInfo: funcionario.calçado,
      enderecoCep: funcionario.enderecoCep ?? "",
      enderecoCidade: funcionario.enderecoCidade ?? "",
      enderecoEndereco: funcionario.enderecoRua ?? "",
      enderecoNumero: funcionario.enderecoNumero ?? "",
      enderecoComplemento: funcionario.enderecoApartamento ?? "",
      enderecoBairro: funcionario.enderecoBairro ?? "",
      enderecoEstado: funcionario.enderecoUf ?? "",
      enderecoPais: funcionario.enderecoPais ?? "",
      bancTipoInfo: funcionario.tipoConta,
      bancBancoInfo: funcionario.nomeBanco,
      bancAgenciaInfo: funcionario.agencia,
      bancContaInfo: funcionario.nrConta,
      bancContaDigitoInfo: funcionario.digito,
      bancOperacaoInfo: funcionario.operacao,
      bancPixInfo: funcionario.pix,
      observacaoGeral: funcionario.anotacoesgerais,
      observacaoDocumento: funcionario.anotacoesdocumentos,
      demissaoData: funcionario.datademissao
        ? dayjs(funcionario.datademissao).toDate()
        : null,
      inicioAvisoPrevio: funcionario.inicioAvisoPrevio
        ? dayjs(funcionario.inicioAvisoPrevio).toDate()
        : null,
      fimAvisoPrevio: funcionario.fimAvisoPrevio
        ? dayjs(funcionario.fimAvisoPrevio).toDate()
        : null,
      cargo: funcionario.cargoDescricao,
      documentosEntregues: null,
      hasProfileImage: funcionario.hasProfileImage,
      horarioTrabalhoSegQui: funcionario.horarioTrabalhoSegQui,
      horarioTrabalhoSex: funcionario.horarioTrabalhoSex,
    };
  }

  async createFuncionario(funcionario: Funcionario): Promise<number> {
    if (!funcionario.idCargo) throw new Error("Falha ao criar usuário!");
    if (!funcionario.idCentroCusto) throw new Error("Falha ao criar usuário!");
    if (!funcionario.nome) throw new Error("Falha ao criar usuário!");
    if (!funcionario.sexo) throw new Error("Falha ao criar usuário!");
    if (!funcionario.dataAdmissao) throw new Error("Falha ao criar usuário!");

    const response = await this.service.createFuncionario(funcionario);

    return response.idFuncionario;
  }

  async updateFuncionario(funcionario: Funcionario): Promise<void> {
    if (!funcionario.idFuncionario)
      throw new Error("Falha ao atualizar usuário!");
    if (!funcionario.idCargo) throw new Error("Falha ao atualizar usuário!");
    if (!funcionario.idCentroCusto)
      throw new Error("Falha ao atualizar usuário!");
    if (!funcionario.nome) throw new Error("Falha ao atualizar usuário!");
    if (!funcionario.sexo) throw new Error("Falha ao atualizar usuário!");
    if (!funcionario.dataAdmissao)
      throw new Error("Falha ao atualizar usuário!");

    await this.service.updateFuncionario(funcionario);
  }

  async deleteFuncionario(
    idTela: number,
    idFuncionario: number,
  ): Promise<void> {
    await this.service.deleteFuncionario({ idTela, idFuncionario });
  }

  async createCentroCustoSecundario(
    idFuncionario: number,
    idCentroCusto: number,
  ): Promise<void> {
    await this.service.createCentroCustoSecundario({
      idFuncionario,
      idCentroCusto,
    });
  }

  async updateCentroCustoSecundario(
    idFuncionarioCentroCusto: number,
    idCentroCusto: number,
  ): Promise<void> {
    await this.service.updateCentroCustoSecundario({
      idFuncionarioCentroCusto,
      idCentroCusto,
    });
  }

  async deleteCentroCustoSecundario(
    idCentroCustoSecundario: number,
  ): Promise<void> {
    await this.service.deleteCentroCustoSecundario({ idCentroCustoSecundario });
  }

  async createDependente(
    idFuncionario: number,
    nome: string,
    grauParentesco: string,
    identidade: string,
    cpf: string,
    dataNascimento: string | null,
  ): Promise<void> {
    await this.service.createDependente({
      idFuncionario,
      nome,
      grauParentesco,
      identidade,
      cpf,
      dataNascimento,
    });
  }

  async updateDependente(
    idFuncionarioDependente: number,
    nome: string,
    grauParentesco: string,
    identidade: string,
    cpf: string,
    dataNascimento: string | null,
  ): Promise<void> {
    await this.service.updateDependente({
      idFuncionarioDependente,
      nome,
      grauParentesco,
      identidade,
      cpf,
      dataNascimento,
    });
  }

  async deleteDependente(idDependente: number): Promise<void> {
    await this.service.deleteDependente({ idDependente });
  }

  async createEvento(
    idFuncionario: number,
    idItemVerba: number,
    valorVerba: number | null,
    descricao: string | null,
  ): Promise<void> {
    await this.service.createEvento({
      idFuncionario,
      idItemVerba,
      valorVerba,
      descricao,
    });
  }

  async updateEvento(
    idItemVerbaFuncionario: number,
    idItemVerba: number,
    valorVerba: number | null,
    descricao: string | null,
  ): Promise<void> {
    await this.service.updateEvento({
      idItemVerbaFuncionario,
      idItemVerba,
      valorVerba,
      descricao,
    });
  }

  async deleteEvento(idEvento: number): Promise<void> {
    await this.service.deleteEvento({ idEvento });
  }

  async createFerias(
    idFuncionario: number,
    descricao: string,
    dataInicio: Date,
    dataTermino: Date,
  ): Promise<void> {
    await this.service.createFerias({
      idFuncionario,
      descricao,
      dataInicio,
      dataTermino,
    });
  }

  async updateFerias(
    idFuncionarioFerias: number,
    descricao: string,
    dataInicio: Date,
    dataTermino: Date,
  ): Promise<void> {
    await this.service.updateFerias({
      idFuncionarioFerias,
      descricao,
      dataInicio,
      dataTermino,
    });
  }

  async deleteFerias(idFerias: number): Promise<void> {
    await this.service.deleteFerias({ idFerias });
  }

  async createAfastamento(
    idFuncionario: number,
    idMotivoAfastamento: number,
    observacao: string,
    dataInicio: Date,
    dataTermino: Date,
  ): Promise<void> {
    await this.service.createAfastamento({
      idFuncionario,
      idMotivoAfastamento,
      observacao,
      dataInicio,
      dataTermino,
    });
  }

  async updateAfastamento(
    idFuncionarioAfastamento: number,
    idMotivoAfastamento: number,
    observacao: string,
    dataInicio: Date,
    dataTermino: Date,
  ): Promise<void> {
    await this.service.updateAfastamento({
      idFuncionarioAfastamento,
      idMotivoAfastamento,
      observacao,
      dataInicio,
      dataTermino,
    });
  }

  async deleteAfastamento(idAfastamento: number): Promise<void> {
    await this.service.deleteAfastamento({ idAfastamento });
  }

  async createDocumento(
    idFuncionario: number,
    nomeDocumento: string,
    statusArquivo: number | null,
    dataVencimento: Date | null,
    dataEmissao: Date | null,
    arquivo: File | null,
  ): Promise<void> {
    await this.service.createDocumento({
      idFuncionario,
      nomeDocumento,
      statusArquivo,
      dataVencimento,
      dataEmissao,
      arquivo,
    });
  }

  async updateDocumento(
    idFuncionarioDocumento: number,
    nomeDocumento: string,
    statusArquivo: number | null,
    dataVencimento: Date | null,
    dataEmissao: Date | null,
    arquivo: File | null,
    limparArquivo: boolean,
  ): Promise<void> {
    await this.service.updateDocumento({
      idFuncionarioDocumento,
      nomeDocumento,
      statusArquivo,
      dataVencimento,
      dataEmissao,
      arquivo,
      limparArquivo,
    });
  }

  async deleteDocumento(idDocumento: number): Promise<void> {
    await this.service.deleteDocumento({ idDocumento });
  }

  async deleteAllDocumentos(idFuncionario: number): Promise<void> {
    await this.service.deleteAllDocumentos({ idFuncionario });
  }

  async createFuncionarioTreinamento(
    idFuncionario: number,
    idTreinamento: number,
    cargaHoraria: number,
    dataRealização: Date,
    instrutor: string,
    local: string,
    prazoAvaliacao: number,
  ): Promise<void> {
    await this.service.createAvaliacaoTreinamento({
      idFuncionario,
      idTreinamento,
      cargaHoraria,
      dataInicio: dataRealização,
      instrutor,
      local,
      prazoAvaliacao,
    });
  }

  async updateFuncionarioTreinamento(
    idFuncionarioTreinamento: number,
    idTreinamento: number,
    cargaHoraria: number,
    dataRealização: Date,
    instrutor: string,
    local: string,
    prazoAvaliacao: number,
  ): Promise<void> {
    await this.service.updateAvaliacaoTreinamento({
      idFuncionarioTreinamento,
      idTreinamento,
      cargaHoraria,
      dataInicio: dataRealização,
      instrutor,
      local,
      prazoAvaliacao,
    });
  }

  async deleteFuncionarioTreinamento(
    idFuncionarioTreinamento: number,
  ): Promise<void> {
    await this.service.deleteFuncionarioTreinamento({
      idFuncionarioTreinamento,
    });
  }

  async deleteFuncionarioTreinamentosLote(
    idFuncionario: number,
    idFuncionarioTreinamentosLote: number[],
    originScreen?: number,
  ): Promise<void> {
    await this.service.deleteFuncionarioTreinamentosLote({
      idFuncionario,
      idFuncionarioTreinamentosLote,
      originScreen,
    });
  }

  async avaliarTreinamento(
    idFuncionarioTreinamento: number | null,
    idFuncionarioTreinamentoLote: number[] | null,
    eficaz: number,
    avaliador: string | null,
    dataAvaliacao: Date | null,
    evidenciaObjetiva: string | null,
    originScreen: number,
  ): Promise<void> {
    await this.service.avaliarTreinamento({
      idFuncionarioTreinamento,
      idFuncionarioTreinamentoLote,
      avaliador,
      dataAvaliacao,
      eficaz,
      evidenciaObjetiva,
      originScreen,
    });
  }

  async createAvaliacaoHabilidade(
    idFuncionario: number,
    idCargo: number,
  ): Promise<{
    avaliacaoHabilidade: AvaliacaoHabilidade;
    habilidades: HabilidadeItem[];
  }> {
    const { avaliacaoHabilidade, habilidades } =
      await this.service.createAvaliacaoHabilidade({
        idFuncionario,
        idCargo,
      });

    return {
      avaliacaoHabilidade: {
        idAvaliacaoHabilidade: avaliacaoHabilidade.idAvaliacaoHabilidade,
        idAvaliadoPor: avaliacaoHabilidade.idFuncionarioAvaliador,
        prazoAvaliacao: avaliacaoHabilidade.dataAvaliacao
          ? dayjs(avaliacaoHabilidade.dataAvaliacao).toDate()
          : null,
        dataAvaliacao: avaliacaoHabilidade.dataAvaliacaoReal
          ? dayjs(avaliacaoHabilidade.dataAvaliacaoReal).toDate()
          : null,
        avaliacao: avaliacaoHabilidade.descricao,
        avaliador: avaliacaoHabilidade.avaliador,
        totalPontos: avaliacaoHabilidade.nota,
        status: avaliacaoHabilidade.status ?? 0,
        descricao: avaliacaoHabilidade.descricao ?? "",
        dataReavaliacao: avaliacaoHabilidade.dataReavaliacao
          ? dayjs(avaliacaoHabilidade.dataReavaliacao).toDate()
          : null,
        observacao: avaliacaoHabilidade.observacoes ?? "",
      },
      habilidades: habilidades.map(
        (x): HabilidadeItem => ({
          idHabilidadeItem: x.idFuncionarioHabilidade,
          idHabilidade: x.idHabilidade,
          habilidade: x.tipo ?? "",
          nota: x.nota,
        }),
      ),
    };
  }

  async updateAvaliacaoHabilidade(
    idAvaliacaoHabilidade: number,
    descricao: string,
    data: Date,
    idAvaliadoPor: number,
    dataReavaliacao: Date | null,
    observacao: string,
    notas: {
      idAvaliacaoHabilidadeItem: number;
      nota: number | null;
    }[],
  ): Promise<void> {
    await this.service.updateAvaliacaoHabilidade({
      idAvaliacaoHabilidade,
      descricao,
      data,
      idAvaliadoPor,
      dataReavaliacao,
      observacao,
      notas,
    });
  }

  async deleteAvaliacaoHabilidade(
    idAvaliacaoHabilidade: number,
  ): Promise<void> {
    await this.service.deleteAvaliacaoHabilidade({ idAvaliacaoHabilidade });
  }

  async createAvaliacaoHabilidadeItem(
    idAvaliacaoHabilidade: number,
    idHabilidade: number,
    nota: number | null,
  ): Promise<{
    avaliacaoHabilidade: AvaliacaoHabilidade;
    habilidades: HabilidadeItem[];
  }> {
    const { avaliacaoHabilidade, habilidades } =
      await this.service.createAvaliacaoHabilidadeItem({
        idAvaliacaoHabilidade,
        idHabilidade,
        nota,
      });

    return {
      avaliacaoHabilidade: {
        idAvaliacaoHabilidade: avaliacaoHabilidade.idAvaliacaoHabilidade,
        idAvaliadoPor: avaliacaoHabilidade.idFuncionarioAvaliador,
        prazoAvaliacao: avaliacaoHabilidade.dataAvaliacao
          ? dayjs(avaliacaoHabilidade.dataAvaliacao).toDate()
          : null,
        dataAvaliacao: avaliacaoHabilidade.dataAvaliacaoReal
          ? dayjs(avaliacaoHabilidade.dataAvaliacaoReal).toDate()
          : null,
        avaliacao: avaliacaoHabilidade.descricao,
        avaliador: avaliacaoHabilidade.avaliador,
        totalPontos: avaliacaoHabilidade.nota,
        status: avaliacaoHabilidade.status ?? 0,
        descricao: avaliacaoHabilidade.descricao ?? "",
        dataReavaliacao: avaliacaoHabilidade.dataReavaliacao
          ? dayjs(avaliacaoHabilidade.dataReavaliacao).toDate()
          : null,
        observacao: avaliacaoHabilidade.observacoes ?? "",
      },
      habilidades: habilidades.map(
        (x): HabilidadeItem => ({
          idHabilidadeItem: x.idFuncionarioHabilidade,
          idHabilidade: x.idHabilidade,
          habilidade: x.tipo ?? "",
          nota: x.nota,
        }),
      ),
    };
  }

  async updateAvaliacaoHabilidadeItem(
    idAvaliacaoHabilidadeItem: number,
    idHabilidade: number,
    nota: number | null,
  ): Promise<{
    avaliacaoHabilidade: AvaliacaoHabilidade;
    habilidades: HabilidadeItem[];
  }> {
    const { avaliacaoHabilidade, habilidades } =
      await this.service.updateAvaliacaoHabilidadeItem({
        idAvaliacaoHabilidadeItem,
        idHabilidade,
        nota,
      });

    return {
      avaliacaoHabilidade: {
        idAvaliacaoHabilidade: avaliacaoHabilidade.idAvaliacaoHabilidade,
        idAvaliadoPor: avaliacaoHabilidade.idFuncionarioAvaliador,
        prazoAvaliacao: avaliacaoHabilidade.dataAvaliacao
          ? dayjs(avaliacaoHabilidade.dataAvaliacao).toDate()
          : null,
        dataAvaliacao: avaliacaoHabilidade.dataAvaliacaoReal
          ? dayjs(avaliacaoHabilidade.dataAvaliacaoReal).toDate()
          : null,
        avaliacao: avaliacaoHabilidade.descricao,
        avaliador: avaliacaoHabilidade.avaliador,
        totalPontos: avaliacaoHabilidade.nota,
        status: avaliacaoHabilidade.status ?? 0,
        descricao: avaliacaoHabilidade.descricao ?? "",
        dataReavaliacao: avaliacaoHabilidade.dataReavaliacao
          ? dayjs(avaliacaoHabilidade.dataReavaliacao).toDate()
          : null,
        observacao: avaliacaoHabilidade.observacoes ?? "",
      },
      habilidades: habilidades.map(
        (x): HabilidadeItem => ({
          idHabilidadeItem: x.idFuncionarioHabilidade,
          idHabilidade: x.idHabilidade,
          habilidade: x.tipo ?? "",
          nota: x.nota,
        }),
      ),
    };
  }

  async deleteAvaliacaoHabilidadeItem(
    idAvaliacaoHabilidadeItem: number,
  ): Promise<{
    avaliacaoHabilidade: AvaliacaoHabilidade;
    habilidades: HabilidadeItem[];
  }> {
    const { avaliacaoHabilidade, habilidades } =
      await this.service.deleteAvaliacaoHabilidadeItem({
        idAvaliacaoHabilidadeItem,
      });

    return {
      avaliacaoHabilidade: {
        idAvaliacaoHabilidade: avaliacaoHabilidade.idAvaliacaoHabilidade,
        idAvaliadoPor: avaliacaoHabilidade.idFuncionarioAvaliador,
        prazoAvaliacao: avaliacaoHabilidade.dataAvaliacao
          ? dayjs(avaliacaoHabilidade.dataAvaliacao).toDate()
          : null,
        dataAvaliacao: avaliacaoHabilidade.dataAvaliacaoReal
          ? dayjs(avaliacaoHabilidade.dataAvaliacaoReal).toDate()
          : null,
        avaliacao: avaliacaoHabilidade.descricao,
        avaliador: avaliacaoHabilidade.avaliador,
        totalPontos: avaliacaoHabilidade.nota,
        status: avaliacaoHabilidade.status ?? 0,
        descricao: avaliacaoHabilidade.descricao ?? "",
        dataReavaliacao: avaliacaoHabilidade.dataReavaliacao
          ? dayjs(avaliacaoHabilidade.dataReavaliacao).toDate()
          : null,
        observacao: avaliacaoHabilidade.observacoes ?? "",
      },
      habilidades: habilidades.map(
        (x): HabilidadeItem => ({
          idHabilidadeItem: x.idFuncionarioHabilidade,
          idHabilidade: x.idHabilidade,
          habilidade: x.tipo ?? "",
          nota: x.nota,
        }),
      ),
    };
  }

  async createControlePatrimonio(
    idFuncionario: number,
    idMaquinaEquip: number,
    dataEntrega: Date | null,
    dataDevolucao: Date | null,
    observacoes: string | null,
    nomeArquivo: string | null,
    arquivo: File | null,
  ): Promise<void> {
    await this.service.createControlePatrimonio({
      idFuncionario,
      idMaquinaEquip,
      dataEntrega,
      dataDevolucao,
      observacoes,
      nomeArquivo,
      arquivo,
    });
  }

  async updateControlePatrimonio(
    idControlePatrimonio: number,
    idMaquinaEquip: number,
    dataEntrega: Date | null,
    dataDevolucao: Date | null,
    observacoes: string | null,
    nomeArquivo: string | null,
    arquivo: File | null,
  ): Promise<void> {
    await this.service.updateControlePatrimonio({
      idControlePatrimonio,
      idMaquinaEquip,
      dataEntrega,
      dataDevolucao,
      observacoes,
      nomeArquivo,
      arquivo,
    });
  }

  async deleteControlePatrimonio(idControlePatrimonio: number): Promise<void> {
    await this.service.deleteControlePatrimonio({ idControlePatrimonio });
  }

  async getFuncionariosAllDocumentos(
    idFuncionario: number,
  ): Promise<JobStatusResponse> {
    return await this.service.getFuncionariosAllDocumentos({ idFuncionario });
  }

  async getMotivosDemissao(
    tipoPesquisa: number,
    motivoDemissao: string,
    status: number,
    page: number,
    pageSize: number,
  ): Promise<Paginated<MotivoDemissao>> {
    return await this.service.getMotivosDemissao({
      tipoPesquisa,
      motivoDemissao,
      status,
      page,
      pageSize,
    });
  }

  async createMotivoDemissao(
    ativo: boolean,
    descricaoMotivo: string,
  ): Promise<number> {
    const response = await this.service.createMotivoDemissao({
      ativo,
      descricaoMotivo,
    });
    return response.id;
  }

  async updateMotivoDemissao(
    idMotivoDemissao: number,
    ativo: boolean,
    descricaoMotivo: string,
  ): Promise<void> {
    await this.service.updateMotivoDemissao({
      idMotivoDemissao,
      ativo,
      descricaoMotivo,
    });
  }

  async deleteMotivoDemissao(idMotivoDemissao: number): Promise<void> {
    await this.service.deleteMotivoDemissao({
      idMotivoDemissao,
    });
  }

  async getFuncionarioAssinaturas(
    idFuncionario: number,
    status: number,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<FuncionarioAssinatura>> {
    return await this.service.getAssinaturas({
      idFuncionario,
      status,
      page,
      rowsPerPage,
    });
  }

  async createFuncionarioAssinatura(
    ativo: number,
    idFuncionario: number,
    arquivo: File | null,
    nroRegistro: string | null,
  ): Promise<void> {
    await this.service.createFuncionarioAssinatura({
      ativo,
      idFuncionario,
      arquivo,
      nroRegistro,
    });
  }

  async updateFuncionarioAssinatura(
    idFuncionarioAssinatura: number,
    ativo: number,
    idFuncionario: number,
    arquivo: File | null,
    nroRegistro: string | null,
    limparArquivo: boolean,
  ): Promise<void> {
    await this.service.updateFuncionarioAssinatura({
      idFuncionarioAssinatura,
      ativo,
      idFuncionario,
      arquivo,
      nroRegistro,
      limparArquivo,
    });
  }

  async deleteFuncionarioAssinatura(
    idFuncionarioAssinatura: number,
  ): Promise<void> {
    await this.service.deleteFuncionarioAssinatura({
      idFuncionarioAssinatura,
    });
  }

  async getMotivosAfastamento(
    tipoPesquisa: number,
    motivoAfastamento: string,
    status: number,
    page: number,
    pageSize: number,
  ): Promise<Paginated<MotivoAfastamento>> {
    return await this.service.getMotivosAfastamento({
      tipoPesquisa,
      motivoAfastamento,
      status,
      page,
      pageSize,
    });
  }

  async createMotivoAfastamento(
    ativo: boolean,
    descricaoMotivo: string,
  ): Promise<void> {
    await this.service.createMotivoAfastamento({
      ativo,
      descricaoMotivo,
    });
  }

  async updateMotivoAfastamento(
    idMotivoAfastamento: number,
    ativo: boolean,
    descricaoMotivo: string,
  ): Promise<void> {
    await this.service.updateMotivoAfastamento({
      idMotivoAfastamento,
      ativo,
      descricaoMotivo,
    });
  }

  async deleteMotivoAfastamento(idMotivoAfastamento: number): Promise<void> {
    await this.service.deleteMotivoAfastamento({
      idMotivoAfastamento,
    });
  }

  async createCargo(
    ativo: number,
    atribuicoes: string,
    descricao: string,
    escolaridade: string,
    experiencia: string,
    qualificacoes: string,
    treinamentos: number[],
    habilidades: number[],
  ): Promise<number> {
    const response = await this.service.createCargo({
      ativo,
      atribuicoes,
      descricao,
      escolaridade,
      experiencia,
      qualificacoes,
      treinamentos,
      habilidades,
    });
    return response.idCargo;
  }

  async updateCargo(
    idCargo: number,
    ativo: number,
    atribuicoes: string,
    descricao: string,
    escolaridade: string,
    experiencia: string,
    qualificacoes: string,
    treinamentos: number[],
    habilidades: number[],
  ): Promise<void> {
    await this.service.updateCargo({
      idCargo,
      ativo,
      atribuicoes,
      descricao,
      escolaridade,
      experiencia,
      qualificacoes,
      treinamentos,
      habilidades,
    });
  }

  async copyCargo(idCargo: number, descricao: string): Promise<void> {
    await this.service.copyCargo({ idCargo, descricao });
  }

  async getAllCargo(
    nome: string,
    atribuicoes: string,
    escolaridade: string,
    status: number,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<Cargo>> {
    return await this.service.getAllCargo({
      nome,
      atribuicoes,
      escolaridade,
      status,
      page,
      rowsPerPage,
    });
  }

  async getCargoTreinamentos(
    idCargo: number | null,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<CargoTreinamento>> {
    return await this.service.getCargoTreinamentos({
      idCargo,
      page,
      rowsPerPage,
    });
  }

  async getCargoHabilidades(
    idCargo: number | null,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<CargoHabilidade>> {
    return await this.service.getCargoHabilidades({
      idCargo,
      page,
      rowsPerPage,
    });
  }

  async getCargoById(idCargo: number): Promise<CargoCompleto> {
    return this.service.getCargoById({ idCargo });
  }

  async deleteCargo(idCargo: number): Promise<void> {
    await this.service.deleteCargo({ idCargo });
  }

  async getAllTreinamentos(
    tipoPesquisa: number,
    valueField: string,
    status: number,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<Treinamento>> {
    return await this.service.getAllTreinamentos({
      tipoPesquisa,
      valueField,
      status,
      page,
      rowsPerPage,
    });
  }

  async createTreinamento(
    ativo: number,
    nome: string,
    versao: string,
    cargaHoraria: number,
    conteudoProgramatico: string | null,
  ): Promise<void> {
    await this.service.createTreinamento({
      ativo,
      nome,
      versao,
      cargaHoraria,
      conteudoProgramatico,
    });
  }

  async updateTreinamento(
    idTreinamento: number,
    ativo: number,
    nome: string,
    versao: string,
    cargaHoraria: number,
    conteudoProgramatico: string | null,
  ): Promise<void> {
    await this.service.updateTreinamento({
      idTreinamento,
      ativo,
      nome,
      versao,
      cargaHoraria,
      conteudoProgramatico,
    });
  }

  async deleteTreinamento(idTreinamento: number): Promise<void> {
    await this.service.deleteTreinamento({
      idTreinamento,
    });
  }

  async copyTreinamento(
    idTreinamento: number,
    nome: string,
    versao: string,
    cargaHoraria: number,
  ): Promise<void> {
    await this.service.copyTreinamento({
      idTreinamento,
      nome,
      versao,
      cargaHoraria,
    });
  }

  async inativarTreinamentos(treinamentos: number[]): Promise<void> {
    await this.service.inativarTreinamentos({
      treinamentos,
    });
  }

  async getAllTreinamentoTreinamentoCargo(): Promise<
    TreinamentoTreinamentoCargo[]
  > {
    const response = await this.service.getAllTreinamentoTreinamentoCargo({});
    return response.items;
  }

  async getAllCargoTreinamentoCargo(
    idTreinamento: number,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<CargoTreinamentoCargo>> {
    return this.service.getAllCargoTreinamentoCargo({
      idTreinamento,
      page,
      rowsPerPage,
    });
  }

  async saveCargoTreinamento(
    idTreinamento: number,
    cargoIds: number[],
  ): Promise<void> {
    await this.service.saveCargoTreinamento({
      idTreinamento,
      cargoIds,
    });
  }

  async getAllHabilidade(
    tipoPesquisa: number,
    valueField: string,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<Habilidade>> {
    return await this.service.getAllHabilidade({
      tipoPesquisa,
      valueField,
      page,
      rowsPerPage,
    });
  }

  async createHabilidade(habilidade: string, descricao: string): Promise<void> {
    await this.service.createHabilidade({
      habilidade,
      descricao,
    });
  }

  async updateHabilidade(
    idHabilidade: number,
    habilidade: string,
    descricao: string,
  ): Promise<void> {
    await this.service.updateHabilidade({
      idHabilidade,
      habilidade,
      descricao,
    });
  }

  async deleteHabilidade(idHabilidade: number): Promise<void> {
    await this.service.deleteHabilidade({
      idHabilidade,
    });
  }

  async getAllHabilidadeHabilidadeCargo(): Promise<
    HabilidadeHabilidadeCargo[]
  > {
    const response = await this.service.getAllHabilidadeHabilidadeCargo({});
    return response.items;
  }

  async getAllCargoHabilidadeCargo(
    idHabilidade: number,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<CargoHabilidadeCargo>> {
    return this.service.getAllCargoHabilidadeCargo({
      idHabilidade,
      page,
      rowsPerPage,
    });
  }

  async saveCargoHabilidade(
    idHabilidade: number,
    cargoIds: number[],
  ): Promise<void> {
    await this.service.saveCargoHabilidade({
      idHabilidade,
      cargoIds,
    });
  }

  async getAllAvaliacaoTreinamentoLote(
    idCargo: number | null,
    idFuncionario: number | null,
    idCentroCusto: number[] | null,
    vencimentoDe: Date | null,
    vencimentoAte: Date | null,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<AvaliacaoTreinamento>> {
    return await this.service.getAllAvaliacaoTreinamentoLote({
      idCargo,
      idFuncionario,
      idCentroCusto,
      vencimentoDe,
      vencimentoAte,
      page,
      rowsPerPage,
    });
  }

  async avaliarTreinamentoLote(
    idFuncionarioTreinamentoLote: number[],
    eficaz: number,
    avaliador: string | null,
    dataAvaliacao: Date | null,
    evidenciaObjetiva: string | null,
  ): Promise<void> {
    await this.service.avaliarTreinamentoLote({
      idFuncionarioTreinamentoLote,
      eficaz,
      avaliador,
      dataAvaliacao,
      evidenciaObjetiva,
    });
  }

  async getAllTreinamentoFuncionario(
    cargos: number[],
    centroCustos: number[],
  ): Promise<TreinamentoFuncionario[]> {
    const response = await this.service.getAllTreinamentoFuncionario({
      cargoIds: cargos,
      centroCustoIds: centroCustos,
    });
    return response.items;
  }

  async saveTreinamentoFuncionario(
    treinamentoIds: number[],
    funcionarioIds: number[],
    dataRealizacao: Date,
    local: string,
    instrutor: string,
    prazoAvaliacao: number,
    instrutorAssinatura1: number | null,
    instrutorAssinatura2: number | null,
    instrutorAssinatura3: number | null,
  ): Promise<void> {
    await this.service.saveTreinamentoFuncionario({
      treinamentoIds,
      funcionarioIds,
      dataRealizacao,
      local,
      instrutor,
      prazoAvaliacao,
      instrutorAssinatura1,
      instrutorAssinatura2,
      instrutorAssinatura3,
    });
  }

  async getAllTreinamentoFuncionarioData(): Promise<
    TreinamentoFuncionarioData[]
  > {
    const response = await this.service.getAllTreinamentoFuncionarioData({});
    return response.items;
  }

  async getAllTreinamentoFuncionarioAssinatura(): Promise<
    TreinamentoFuncionarioAssinatura[]
  > {
    const response = await this.service.getAllTreinamentoFuncionarioAssinatura(
      {},
    );
    return response.items;
  }

  async getAllTreinamentoFuncionarioInstrutor(
    data: string,
  ): Promise<TreinamentoFuncionarioInstrutor[]> {
    const response = await this.service.getAllTreinamentoFuncionarioInstrutor({
      data,
    });
    return response.items;
  }

  async getAllTreinamentoFuncionarioLocal(
    data: string,
    instrutor: string,
  ): Promise<TreinamentoFuncionarioLocal[]> {
    const response = await this.service.getAllTreinamentoFuncionarioLocal({
      data,
      instrutor,
    });
    return response.items;
  }

  async getAllFolhaPagamento(
    tipoPesquisa: number,
    valorPesquisa: string | null,
    idFuncionario: number | null,
    dataCadastro: Date | null,
    dataPagamento: Date | null,
    numero: string | null,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<FolhaPagamento>> {
    return await this.service.getAllFolhaPagamento({
      tipoPesquisa,
      valorPesquisa,
      idFuncionario,
      dataCadastro,
      dataPagamento,
      numero,
      page,
      rowsPerPage,
    });
  }

  async createFolhaPagamento(
    dataCadastro: Date,
    dataPagamento: Date,
    descricao: string,
    tipo: number,
  ): Promise<void> {
    await this.service.createFolhaPagamento({
      dataCadastro,
      dataPagamento,
      descricao,
      tipo,
    });
  }

  async updateFolhaPagamento(
    idFolhaPagamento: number,
    dataCadastro: Date,
    dataPagamento: Date,
    descricao: string,
    tipo: number,
  ): Promise<void> {
    await this.service.updateFolhaPagamento({
      idFolhaPagamento,
      dataCadastro,
      dataPagamento,
      descricao,
      tipo,
    });
  }

  async deleteFolhaPagamento(idFolhaPagamento: number): Promise<void> {
    await this.service.deleteFolhaPagamento({
      idFolhaPagamento,
    });
  }

  async copyFolhaPagamento(
    idFolhaPagamento: number,
    dataCadastro: Date,
    dataPagamento: Date,
    descricao: string,
  ): Promise<void> {
    await this.service.copyFolhaPagamento({
      idFolhaPagamento,
      dataCadastro,
      dataPagamento,
      descricao,
    });
  }

  async getFiltroFolhaPagamento(): Promise<FiltroFolhaPagamento | null> {
    const response = await this.service.getFiltroFolhaPagamento({});
    return response.item;
  }

  async createFiltroFolhaPagamento(colunas: string[]): Promise<void> {
    await this.service.createFiltroFolhaPagamento({ colunas });
  }

  async getAllFolhaPagamentoItens(
    idFolhaPagamento: number,
    idCentroCusto: number | null,
    idFuncionario: number | null,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<ItemFolhaPagamento>> {
    return await this.service.getAllFolhaPagamentoItens({
      idFolhaPagamento,
      idCentroCusto,
      idFuncionario,
      page,
      rowsPerPage,
    });
  }

  async getFolhaPagamento(
    idFolhaPagamento: number,
  ): Promise<FolhaPagamento | null> {
    const response = await this.service.getFolhaPagamento({ idFolhaPagamento });
    return response.item;
  }

  async getSubcontasDropDown(): Promise<SubcontaDropdown[]> {
    const response = await this.service.getSubcontasDropDown({});

    var normalized = response.items.map((x) => ({
      id: x.idSubconta,
      title: x.descricao,
    }));

    return [...normalized];
  }

  async createItemFolhaPagamento(
    idFolhaPagamento: number,
    idCentroCusto: number,
    idFuncionarios: number[],
    idFuncionarioResponsavel: number,
    dataPagamento: Date,
    idSubconta: number | null,
  ): Promise<void> {
    await this.service.createItemFolhaPagamento({
      idFolhaPagamento,
      idCentroCusto,
      idFuncionarios,
      idFuncionarioResponsavel,
      dataPagamento,
      idSubconta,
    });
  }

  async updateItemFolhaPagamento(
    idItemFolhaPagamento: number,
    tituloConta: string | null,
    idSubconta: number | null,
    formaPagamento: string | null,
    valorPagar: number | null,
    observacaoFolha: string | null,
  ): Promise<void> {
    await this.service.updateItemFolhaPagamento({
      idItemFolhaPagamento,
      tituloConta,
      idSubconta,
      formaPagamento,
      valorPagar,
      observacaoFolha,
    });
  }

  async deleteItemFolhaPagamento(idItemFolhaPagamento: number): Promise<void> {
    await this.service.deleteItemFolhaPagamento({ idItemFolhaPagamento });
  }

  async getFolhaPagamentoDetalhe(
    idItemFolhaPagamento: number,
  ): Promise<FolhaPagamentoDetalhe> {
    const response = await this.service.getFolhaPagamentoDetalhe({
      idItemFolhaPagamento,
    });
    return response.item;
  }

  async getItemFolhaPagamento(
    idItemFolhaPagamento: number,
  ): Promise<ItemFolhaPagamentoDetalhe> {
    const response = await this.service.getItemFolhaPagamento({
      idItemFolhaPagamento,
    });
    return response.item;
  }

  async getAllItemFolhaPagamentoVerba(
    idItemFolhaPagamento: number,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<ItemFolhaPagamentoVerba>> {
    return this.service.getAllItemFolhaPagamentoVerba({
      idItemFolhaPagamento,
      page,
      rowsPerPage,
    });
  }

  async createItemFolhaPagamentoVerba(
    idItemFolhaPagamento: number,
    idItensVerbaFuncionario: number[],
  ): Promise<void> {
    await this.service.createItemFolhaPagamentoVerba({
      idItemFolhaPagamento,
      idItensVerbaFuncionario,
    });
  }

  async updateItemFolhaPagamentoVerba(
    idItemFolhaPagamentoVerba: number,
    valorUnitario: number | null,
    quantidade: number | null,
  ): Promise<void> {
    await this.service.updateItemFolhaPagamentoVerba({
      idItemFolhaPagamentoVerba,
      valorUnitario,
      quantidade,
    });
  }

  async deleteItemFolhaPagamentoVerba(
    idItemFolhaPagamentoVerba: number,
  ): Promise<void> {
    await this.service.deleteItemFolhaPagamentoVerba({
      idItemFolhaPagamentoVerba,
    });
  }

  async getAllVerbaPagamento(
    tipoPesquisa: number,
    valueField: string,
    page: number,
    rowsPerPage: number,
  ): Promise<Paginated<VerbaPagamento>> {
    return await this.service.getAllVerbaPagamento({
      tipoPesquisa,
      valueField,
      page,
      rowsPerPage,
    });
  }

  async createVerbaPagamento(
    ativo: boolean,
    tipo: number,
    nro: string | null,
    verba: string,
    valor: number | null,
  ): Promise<void> {
    await this.service.createVerbaPagamento({
      ativo,
      tipo,
      nro,
      verba,
      valor,
    });
  }

  async updateVerbaPagamento(
    idItemVerba: number,
    ativo: boolean,
    tipo: number,
    nro: string | null,
    verba: string,
    valor: number | null,
  ): Promise<void> {
    await this.service.updateVerbaPagamento({
      idItemVerba,
      ativo,
      tipo,
      nro,
      verba,
      valor,
    });
  }

  async deleteVerbaPagamento(idItemVerba: number): Promise<void> {
    await this.service.deleteVerbaPagamento({
      idItemVerba,
    });
  }

  async alterarFuncionariosCentroCusto(
    idCentroCusto: number,
    funcionarios: number[],
  ): Promise<void> {
    await this.service.alterarCentroCustoFuncionarios({
      idCentroCusto,
      funcionarios,
    });
  }

  async downloadFuncionarioDocumentoById(
    idFuncionarioArquivo: number,
  ): Promise<Blob> {
    const response = await this.service.downloadFuncionarioDocumentoById({
      idFuncionarioArquivo,
    });
    return response;
  }
  async downloadControlePatrimonioById(
    idControlePatrimonio: number,
  ): Promise<Blob> {
    const response = await this.service.downloadControlePatrimonioById({
      idControlePatrimonio,
    });
    return response;
  }

  async getDashboardRhInformation(): Promise<DashboardRh> {
    const response = await this.service.getDashboardRhInformation({});
    return response.item;
  }
  async getFuncionarioImageById(idFuncionario: number): Promise<Blob> {
    return await this.service.getFuncionarioImageById({ idFuncionario });
  }

  async deleteFuncionarioImageById(idFuncionario: number): Promise<void> {
    await this.service.deleteFuncionarioImageById({ idFuncionario });
  }

  async copyFuncionario(
    idFuncionario: number,
    idCentroCusto: number,
    idCargo: number,
    dataAdmissao: Date,
  ): Promise<void> {
    await this.service.copyFuncionario({
      idFuncionario,
      idCentroCusto,
      idCargo,
      dataAdmissao,
    });
  }

  async downloadFuncionarioAssinatura(
    idFuncionarioAssinatura: number,
  ): Promise<Blob> {
    return await this.service.downloadFuncionarioAssinatura({
      idFuncionarioAssinatura,
    });
  }

  async createBiometriaFacial(
    idFuncionario: number,
    biometriaBase64: string,
  ): Promise<CreateBiometriaFacialResponse> {
    return await this.service.createBiometriaFacial({
      idFuncionario,
      biometriaBase64,
    });
  }

  async createBiometriaFacialFuncionario(
    idFuncionario: number | null,
    data: Date,
    hora: string,
    biometria: string | null,
    idTermoEpi: number,
  ): Promise<void> {
    await this.service.createBiometriaFacialFuncionario({
      idFuncionario,
      data,
      hora,
      biometria,
      idTermoEpi,
    });
  }

  async getBiometriaFacial(
    idFuncionario: number,
  ): Promise<Paginated<BiometriaFacial>> {
    var response = await this.service.getBiometriaFacial({
      idFuncionario,
    });
    return {
      ...response,
      items: response.items.map(
        (item): BiometriaFacial => ({
          IdBiometriaFacial: item.idBiometriaFacial,
          IdFuncionario: item.idFuncionario,
          Data: item.data,
          Hora: item.hora,
          Biometria: item.biometria,
          NomeCadastradoPor: item.nomeCadastradoPor,
          Ativo: item.ativo,
          AuditId: item.auditId,
          IdTermoEPI: item.idTermoEpi,
        }),
      ),
    };
  }
  async inativarBiometriaFacial(
    idFuncionario: number,
  ): Promise<void> {
    await this.service.inativarBiometriaFacial({ idFuncionario });
  }
  async getBiometriaFacialVisualizar(
    idBiometriaFacial: number
  ): Promise<Blob> {
    return await this.service.getBiometriaFacialVisualizar({ idBiometriaFacial });
  }
  async createTermoBiometria(
    idTermoEpi: number,
    idFuncionario: number,
    ativo: boolean,
    biometria: string | null
  ): Promise<void> {
    return await this.service.createTermoBiometria({ idTermoEpi, idFuncionario, ativo, biometria })
  }

  async generateCertificate(
    idFuncionarioTreinamento: number,
  ): Promise<Blob> {
    return await this.service.generateCertificate({ idFuncionarioTreinamento });
  }
}
